import {Component, input, OnInit} from '@angular/core';
import {TrackableEntity} from "../../model/trackable-entity.model";

@Component({
  selector: 'app-view-metric-label',
  templateUrl: './view-metric-label.component.html',
  styleUrls: ['./view-metric-label.component.scss']
})
export class ViewMetricLabelComponent  implements OnInit {

  entity = input<TrackableEntity>();

  constructor() { }

  ngOnInit() {}

}
